import type { BrandThemePalette, ButtonThemePalette } from '../Button.types';
import { radialEffect } from '../animations/radialEffect';

export const secondary = {
  default: ({ button }: ButtonThemePalette): string => `
    background-color: ${button.background.secondary.base};
    color: ${button.text.secondary.base};

    &:hover {
      background-color: ${button.background.secondary.hover};
    }

    ${radialEffect.active(button.background.primary.after)}
  `,
  withLinearGradient: ({
    button,
    brand,
  }: ButtonThemePalette & BrandThemePalette): string => `
    position: relative;

    background-color: ${button.background.secondary.base};
    background-image: ${brand.linear_gradient ?? ''};
    background-size: 100%;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent; 
    -moz-text-fill-color: transparent;
    overflow: unset !important;

    &:before {
      content: '';
      position: absolute;
      border-radius: 0.5rem;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 2px solid transparent;
      background: ${brand.linear_gradient ?? ''} border-box;
      mask:
        linear-gradient(#000 0 0) padding-box, 
        linear-gradient(#000 0 0);
      mask-composite: exclude;
    }

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 0.5rem;
      background: ${brand.linear_gradient ?? ''};
      opacity: 0;
      transition: opacity 0.3s ease-in-out;
    }

    &:hover::after {
      opacity: 0.1;
    }
  `,
};
